import { Forms } from "../../components/backgrounds/Forms";
import { Steps } from "../../components/buttons/Steps";
import { Primary } from "../../components/buttons/Primary";
import TagManager from "../../components/googleTag/TagManager";
import { useEffect } from "react";
import { statusReferrals } from "../../utils/referrals/status";
import { bonusReferrals } from "../../utils/referrals/bonus";
import { APIClient } from "../../helpers/api_helper";
import * as url from "../../helpers/url_helper";
import { FloatFooter } from "../../components/navigation/FloatFooter";
import ViewTimer from "../../components/timers/viewTimer";
import { handleAddTimeline } from "./helpers/helper";

let api = new APIClient();

export function ConfirmadoPage() {
  const handleReferrals = async () => {
    let utm_id = localStorage.getItem("utm_id");
    if (utm_id) {
      if (utm_id.includes("referido")) {
        let idParent = utm_id.split("-")[1];
        let documento = localStorage.getItem("doc");
        let credit_id = localStorage.getItem("credit_id");
        let status = statusReferrals.CF;
        let bonus = bonusReferrals.CF;
        try {
          let responseApi = await api.create(url.CREATE_REFERRALS, {
            payload: { idParent, documento, credit_id, status, bonus },
          });
          console.log(responseApi.data);
          return;
        } catch (e) {
          console.log(e);
          return;
        }
      }
    }
  };

  useEffect(() => {
    handleReferrals();
    localStorage.setItem("fromConfirmed", "true");
  }, []);

  return (
    <div className="bg-purpleLight h-full mb-10">
      <ViewTimer
        creditId={localStorage.getItem('credit_id')}
        viewName="Confirmado"
        description="Has firmado los documentos de tu nuevo crédito con éxito."
        pathView="/confirmado"
        hasSuccess={true}
        onSaveTimeline={handleAddTimeline}
        idOperation={localStorage.getItem('idOperation')}
      />
      {/* <TagManager /> */}
      <Steps
        estado1="complete"
        estado2="complete"
        estado3="complete"
        estado4="complete"
      />
      <Forms
        title="Has firmado los documentos de tu nuevo crédito con éxito."
        description={
          "Ahora haces parte del mundo Galilea, ya puedes empezar a disfrutar nuestros beneficios."
        }
        form={
          <>
            <div className="shadow-lg overflow-hidden rounded-md">
              <div className="px-4 py-5 bg-white sm:p-6">
                <div className="lg:px:4">
                  <div className="2xl:hidden">
                    <h1 className="font-bold">
                      Has firmado los documentos de tu nuevo crédito con éxito.
                    </h1>
                  </div>
                  <span>
                    El desembolso estará depositado en tu cuenta bancaria en
                    máximo 1 día hábil sujeto a las verificaciones de nuestro
                    banco y demás políticas de crédito descritas en los términos
                    y condiciones. Recuerda que en Galilea reportaremos tu
                    comportamiento de pago en centrales de riesgo como
                    Datacrédito. Descúbre qué ventajas tiene tener un buen
                    puntaje de crédito para que sigas creciendo en Galilea.
                  </span>
                </div>
                <div className="grid grid-cols-8 gap-6 pt-10 font-bold">
                  <a
                    href="/blog/como-construir-historial-crediticio"
                    className="col-span-8 xl:col-span-4 ring-1 ring-purple ring-opacity-20 grid content-center h-20 rounded-md transition shadow-lg p-4 bg-white hover:bg-purple hover:text-white"
                  >
                    <div>
                      <span>Cómo construir historial crediticio.</span>
                    </div>
                  </a>
                  <a
                    href="/blog/6-consejos-para-manejar-tus-finanzas"
                    className="col-span-8 xl:col-span-4 ring-1 ring-purple ring-opacity-20 grid content-center h-20 rounded-md transition shadow-lg p-4 bg-white hover:bg-purple hover:text-white"
                  >
                    <div>
                      <span>6 consejos para manejar tus finanzas.</span>
                    </div>
                  </a>
                </div>
                <div className="text-center pt-10">
                  <h3 className="font-bold text-xl">
                    Síguenos en Instagram y Facebook
                  </h3>
                  <div className="flex justify-center pt-2">
                    <a
                      href="https://www.instagram.com/galileafintech/"
                      className="w-8 mx-2"
                    >
                      <svg fill="currentColor" viewBox="0 0 24 24">
                        <path
                          fillRule="evenodd"
                          d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>
                    <a
                      href="https://www.facebook.com/galileafintech"
                      className="w-8"
                    >
                      <svg fill="currentColor" viewBox="0 0 24 24">
                        <path
                          fillRule="evenodd"
                          d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>

              <div className="px-4 py-6 flex justify-end bg-white text-right sm:px-6">
                <a href="/micredito" className="w-56 md:w-56">
                  <Primary text="Ir a mi cuenta" />
                </a>
              </div>
            </div>
          </>
        }
      />
      <FloatFooter />
    </div>
  );
}
